import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"
import { Phone } from "lucide-react"

import { useMultiPhoneSupport } from "@/hooks/useMultiPhoneSupport"

interface MultiPhoneNumberSelectorProps {
  selectedIndex: number
  onSelect: (index: number) => void
  disabled?: boolean
  className?: string
  /** Hide the phone glyph beside each option, for a row that already says "Phone Number". */
  showIcon?: boolean
}

export const MultiPhoneNumberSelector: React.FC<
  MultiPhoneNumberSelectorProps
> = ({
  selectedIndex,
  onSelect,
  disabled = false,
  className = "",
  showIcon = true,
}) => {
  const { phoneNumberOptions } = useMultiPhoneSupport()

  const options = Object.entries(phoneNumberOptions).map(([id, config]) => ({
    id: Number(id),
    displayName: config.displayName,
  }))

  return (
    <Select
      value={selectedIndex.toString()}
      onValueChange={(value) => onSelect(Number(value))}
      disabled={disabled}
    >
      <SelectTrigger aria-label="Caller Phone Number" className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.id.toString()} value={option.id.toString()}>
            <div className="flex items-center gap-2">
              {showIcon && <Phone className="w-4 h-4 text-coval-text-muted" />}
              <span className="text-sm font-medium">{option.displayName}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
